import React, { useState } from "react";

/** One number input, shared by the CA and BOT calculators. Shows a readable,
 *  comma-grouped value until you focus it, then gets out of the way. */
export default function Field({ label, icon: Icon, value, onChange, suffix, hint, labelRight, testid, accent = "#4060FF" }) {
  const [focused, setFocused] = useState(false);
  const [buf, setBuf] = useState("");
  const display = focused
    ? buf
    : (value === "" || value == null ? "" : Number(value).toLocaleString(undefined, { maximumFractionDigits: 8 }));
  return (
    <div data-testid={testid}>
      <label className="text-xs font-medium text-ink-2 mb-1.5 flex items-center justify-between gap-2">
        <span className="flex items-center gap-1.5">{Icon && <Icon size={13} className="text-ink-3" />} {label}</span>
        {labelRight || (hint && <span className="text-[10px] text-ink-3 font-normal">{hint}</span>)}
      </label>
      <div className="relative">
        <input
          type="text" inputMode="decimal" value={display}
          onFocus={() => { setBuf(value === "" || value == null ? "" : String(value)); setFocused(true); }}
          onChange={(e) => {
            const cleaned = e.target.value.replace(/[^0-9.\-]/g, "");
            setBuf(cleaned);
            if (cleaned === "" || cleaned === "-" || cleaned === ".") { onChange(""); return; }
            const n = Number(cleaned);
            if (!isNaN(n)) onChange(n);
          }}
          onBlur={() => setFocused(false)}
          className="w-full px-3.5 py-2.5 rounded-xl bg-white/65 border text-sm font-mono font-semibold tabular-nums focus:outline-none focus:bg-white"
          style={{ borderColor: focused ? accent : "rgba(15,18,38,0.10)" }}
        />
        {suffix && <span className="absolute right-3 top-2.5 text-xs text-ink-3 font-mono">{suffix}</span>}
      </div>
    </div>
  );
}
